import callAPiBase from './base';

const userTagsApi = {
  get: ({ Room, conversationStatus }: { Room: string, conversationStatus: number }) =>
    callAPiBase({
      endpoint: `/api/tags/users?${Room}&conversationStatus=${conversationStatus}`,
      method: 'GET',
      useToken: true,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/api/tags/user',
      method: 'POST',
      useToken: true,
      data,
    }),
  delete: ({ ID, room, conversationStatus }: { ID: string; room: string, conversationStatus: number }) =>
    callAPiBase({
      endpoint: `/api/tags/user?ID=${ID}&room=${room}&conversationStatus=${conversationStatus}`,
      method: 'DELETE',
      useToken: true,
    }),
};

export { userTagsApi };
export default userTagsApi;
